import React, { useEffect, useState } from "react";
import classes from "./FromToDatePickers.module.scss";
import SingleDatePicker from "./SingleDatePicker";
import { useRecoilState } from "recoil";
import { userState } from "../../../../states/userState";
import { setUserToLocalStorage } from "../../../../lib/localStorageManager";
import { format } from "date-fns";

const FromToDatePickers = (props) => {
  const { setFromdate, setTodate, fromDate, toDate, label, disabled } = props;
  // const [startDate, setStartDate] = useState(fromDate);
  // const [endDate, setEndDate] = useState(toDate);
  const [error, setError] = useState("");
  const [user, setUser] = useRecoilState(userState);
  // console.log("Date", startDate, endDate, fromDate, toDate);
  // useEffect(() => {
  //   setStartDate(startDate);
  // }, [startDate, endDate, setStartDate, setEndDate]);
  //子コンポーネントのprops検知
  // useEffect(() => {
  //   setFromdate(startDate);
  //   setUser((prevUser) => {
  //     const updatedUser = {
  //       ...prevUser,
  //       filters: {
  //         ...prevUser.filters,
  //         fromDate: startDate ? format(startDate, "yyyy-MM-dd") : "",
  //       },
  //     };
  //     setUserToLocalStorage(updatedUser);
  //     return updatedUser;
  //   });
  // }, [startDate]);
  // useEffect(() => {
  //   setTodate(endDate);
  //   setUser((prevUser) => {
  //     const updatedUser = {
  //       ...prevUser,
  //       filters: {
  //         ...prevUser.filters,
  //         toDate: endDate ? format(endDate, "yyyy-MM-dd") : "",
  //       },
  //     };
  //     setUserToLocalStorage(updatedUser);
  //     return updatedUser;
  //   });
  // }, [endDate]);
  //親コンポーネントのprops検知
  useEffect(() => {
    setUser((prevUser) => {
      const updatedUser = {
        ...prevUser,
        filters: {
          ...prevUser.filters,
          fromDate: fromDate ? format(fromDate, "yyyy-MM-dd") : "",
        },
      };
      setUserToLocalStorage(updatedUser);
      return updatedUser;
    });
  }, [fromDate]);
  useEffect(() => {
    setUser((prevUser) => {
      const updatedUser = {
        ...prevUser,
        filters: {
          ...prevUser.filters,
          toDate: toDate ? format(toDate, "yyyy-MM-dd") : "",
        },
      };
      setUserToLocalStorage(updatedUser);
      return updatedUser;
    });
  }, [toDate]);
  // useEffect(() => {
  //   //setStartDate(calendar.overtimeFromDate);
  //   setEndDate(calendar.overtimeToDate);
  // }, [calendar]);
  return (
    <div className={classes.mainContainer}>
      <div className={classes.datePickers}>
        <div className={classes.datePicker}>
          <SingleDatePicker
            disabled={disabled}
            // setCurrentDate={setStartDate}
            // currentDate={startDate}
            setCurrentDate={setFromdate}
            currentDate={fromDate}
            order="From"
            setError={setError}
            // compDate={endDate}
            compDate={toDate}
            setCompDate={setTodate}
            label={label}
          />
        </div>
        <div className={classes.datePicker}>
          <SingleDatePicker
            disabled={disabled}
            // setCurrentDate={setEndDate}
            // currentDate={endDate}
            setCurrentDate={setTodate}
            currentDate={toDate}
            order="To"
            setError={setError}
            // compDate={startDate}
            compDate={fromDate}
            setCompDate={setFromdate}
            label={label}
          />
        </div>
      </div>
      {error && <div className={classes.ErrorMessage}>{error}</div>}
    </div>
  );
};

export default FromToDatePickers;
